import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { AdsServices } from '../services';
import { TranslateService } from '@ngx-translate/core';
import { ProvidersServices } from '../../providers/services';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-provider-list-select',
    templateUrl: 'provider-list-select.html',
})
export class ProviderListSelectPage {

    provider_ads: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public adsServices: AdsServices,
        public providersServices: ProvidersServices,
        public translate: TranslateService,
        private toastCtrl: ToastController) {

        this.getElements();
    }

    async getElements() {
        this.adsServices.actual_page = 'Provider Select';
        //Recuperamos el proveedor
        this.provider_ads = await this.adsServices.getProvidersAds('3', this.adsServices.actual_page);
    }

    async insert(provider) {
        //inicialirtzar sin proveedor
        if (!this.check(provider.UID)) { //Buscamos si el ingrediente ya esta anadido
            //Comprovamos que tenga todos los valores
            await this.checkValues(provider);

            var _array = Array();
            _array.push(provider.UID);
            _array.push(provider.name);
            _array.push(provider.nif);
            _array.push(provider.address);
            _array.push(provider.province);
            _array.push(provider.city);
            _array.push(provider.phone);
            _array.push(provider.country);
            _array.push(provider.email);
            _array.push(provider.contact_name);
            _array.push(false);//default
            _array.push(0);//price_notax
            _array.push(0);//tax
            _array.push(0);//price
            //Añadimos els ads_provider_uid para saber que este proveedor viene de ads
            _array['ads_provider_uid'] = provider._ads_provider_uid;
            _array['UID'] = provider.UID;
            this.providersServices.providers_array_tmp.push(_array);
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-proveedor-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }
    check(value) {
        var response = false;
        for (var i = 0; i < this.providersServices.providers_array_tmp.length; i++) {
            var obj = this.providersServices.providers_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }

    checkValues(provider) {
        if(provider.name == undefined){
            provider.name = '';
        }
        if(provider.nif == undefined){
            provider.nif = '';
        }
        if(provider.address == undefined){
            provider.address = '';
        }
        if(provider.province == undefined){
            provider.province = '';
        }
        if(provider.city == undefined){
            provider.city = '';
        }
        if(provider.phone == undefined){
            provider.phone = '';
        }
        if(provider.country == undefined){
            provider.country = '';
        }
        if(provider.email == undefined){
            provider.email = '';
        }
        if(provider.contact_name == undefined){
            provider.contact_name = '';
        }
        if(provider.web == undefined){
            provider.web = '';
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/ads/provider-list-select/provider-list-select.ts